module.exports = __webpack_public_path__ + "img/seven_.6955de92.png";